import React from 'react';
import classes from './CardMenuIdeas.module.scss';
import {withRouter} from "react-router-dom";
import EllipsisText from "react-ellipsis-text";
import {isMobileOnly, isTablet} from "react-device-detect";

const CardMenuIdeas = (props) => {

    const gotoDetail = (slug, paramTitle) => {
        localStorage.setItem('menu_ideas:selected_detail', paramTitle)
        if (props.target !== undefined && props.target === "_blank") {
            if (isMobileOnly || isTablet) {
                props.history.push("/menu-ideas-detail/" + slug);
            } else {
                window.open("/menu-ideas-detail/" + slug)
            }
        } else {
            props.history.push("/menu-ideas-detail/" + slug);
        }
    }

    return (
        <div className={classes.Card_container}
             style={{backgroundImage: `url(${props.data.thumbnail_image})`}}
             onClick={() => gotoDetail(props.data.slug, props.data.title)}>
            <div className={classes.Card_overlay}/>
            <div className={classes.Title_ornament}/>
            {/*<div className={classes.Card_title}>{props.data.title}</div>*/}
            <div className={classes.Card_title}>
                <EllipsisText text={props.data.title.replace(/(<([^>]+)>)/ig, "")} length={255}/>
            </div>

        </div>
    );
}

export default withRouter(CardMenuIdeas);